import Model from 'flarum/common/Model';

export default class Rsvp extends Model {
  status = Model.attribute('status');
  section = Model.attribute('section');
  comment = Model.attribute('comment');
  masqueradeName = Model.attribute('masqueradeName');
  createdAt = Model.attribute('createdAt', Model.transformDate);

  event = Model.hasOne('event');
  user = Model.hasOne('user');
}
